import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=f1e87970&"
import script from "./EmailInput.vue?vue&type=script&lang=js&"
export * from "./EmailInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports